import { render, staticRenderFns } from "./UpdateProvider.vue?vue&type=template&id=68d39758&"
import script from "./UpdateProvider.vue?vue&type=script&lang=js&"
export * from "./UpdateProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports